/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS GPS lost detection api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GridJobConfigSchemaInput
 */
export interface GridJobConfigSchemaInput {
    /**
     * Unique identifier for the record
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    id?: any | null;
    /**
     * Universal unique identifier for the record
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    uuid?: any | null;
    /**
     * Created at this point in time
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    createdAt?: any | null;
    /**
     * Created by this user
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    createdBy?: any | null;
    /**
     * Modified at this point in time
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    modifiedAt?: any | null;
    /**
     * Modified by this user
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    modifiedBy?: any | null;
    /**
     * Name of the job
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    jobName?: any | null;
    /**
     * Interval on hours for gps lost grid calculates
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    updateIntervalHours?: any | null;
    /**
     * Historical range for the job
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    historicalRange?: any | null;
    /**
     * UUID of the shape
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    shapeUuid?: any | null;
    /**
     * Geojson data of the configuration
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    geometryShape?: any | null;
    /**
     * enable the job
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    enabled?: any | null;
    /**
     * grid cell size in meters
     * @type {any}
     * @memberof GridJobConfigSchemaInput
     */
    gridCellSizeMeters?: any | null;
}

/**
 * Check if a given object implements the GridJobConfigSchemaInput interface.
 */
export function instanceOfGridJobConfigSchemaInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GridJobConfigSchemaInputFromJSON(json: any): GridJobConfigSchemaInput {
    return GridJobConfigSchemaInputFromJSONTyped(json, false);
}

export function GridJobConfigSchemaInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GridJobConfigSchemaInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'createdAt': !exists(json, 'created_at') ? undefined : json['created_at'],
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
        'modifiedAt': !exists(json, 'modified_at') ? undefined : json['modified_at'],
        'modifiedBy': !exists(json, 'modified_by') ? undefined : json['modified_by'],
        'jobName': !exists(json, 'job_name') ? undefined : json['job_name'],
        'updateIntervalHours': !exists(json, 'update_interval_hours') ? undefined : json['update_interval_hours'],
        'historicalRange': !exists(json, 'historical_range') ? undefined : json['historical_range'],
        'shapeUuid': !exists(json, 'shape_uuid') ? undefined : json['shape_uuid'],
        'geometryShape': !exists(json, 'geometry_shape') ? undefined : json['geometry_shape'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'gridCellSizeMeters': !exists(json, 'grid_cell_size_meters') ? undefined : json['grid_cell_size_meters'],
    };
}

export function GridJobConfigSchemaInputToJSON(value?: GridJobConfigSchemaInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'uuid': value.uuid,
        'created_at': value.createdAt,
        'created_by': value.createdBy,
        'modified_at': value.modifiedAt,
        'modified_by': value.modifiedBy,
        'job_name': value.jobName,
        'update_interval_hours': value.updateIntervalHours,
        'historical_range': value.historicalRange,
        'shape_uuid': value.shapeUuid,
        'geometry_shape': value.geometryShape,
        'enabled': value.enabled,
        'grid_cell_size_meters': value.gridCellSizeMeters,
    };
}

